import {useMemo, useState} from "../../__snowpack__/pkg/react.js";
import queryString from "../../__snowpack__/pkg/query-string.js";
const defaultPage = 1;
const defaultPageSize = 10;
const defaultPageTotal = 0;
export const usePagination = (dp, dps, dpt) => {
  const [page, setPage] = useState(dp || defaultPage);
  const [pageSize, setPageSize] = useState(dps || defaultPageSize);
  const [pageTotal, setPageTotal] = useState(dpt || defaultPageTotal);
  const pageInfo = useMemo(() => {
    return {page, pageSize, pageTotal};
  }, [page, pageSize, pageTotal]);
  const setPageInfo = (p, ps, pt) => {
    if (p !== void 0) {
      setPage(p);
    }
    if (ps !== void 0) {
      setPageSize(ps);
    }
    if (pt !== void 0) {
      setPageTotal(pt);
    }
    return {
      page: p !== void 0 ? p : page,
      pageSize: ps !== void 0 ? ps : pageSize,
      pageTotal: pt !== void 0 ? pt : pageTotal
    };
  };
  const resetPageInfo = () => {
    const page2 = dp || defaultPage;
    const pageSize2 = dps || defaultPageSize;
    const pageTotal2 = dpt || defaultPageTotal;
    setPage(page2);
    setPageSize(pageSize2);
    setPageTotal(pageTotal2);
    return {page: page2, pageSize: pageSize2, pageTotal: pageTotal2};
  };
  const getPageInfoQuery = (curPageInfo) => {
    const query = queryString.stringify(Object.assign(queryString.parse(location.search), curPageInfo || pageInfo));
    return query;
  };
  const restorePageInfoFromQuery = () => {
    const pageInfo2 = queryString.parse(location.search);
    const {page: page2, pageSize: pageSize2, pageTotal: pageTotal2} = Object.assign(resetPageInfo(), pageInfo2);
    return setPageInfo(page2, pageSize2, pageTotal2);
  };
  return {
    pageInfo,
    setPageInfo,
    resetPageInfo,
    getPageInfoQuery,
    restorePageInfoFromQuery
  };
};
export const getPageCount = (pageTotal, pageSize) => {
  if (!pageTotal || !pageSize) {
    return 0;
  }
  const basic = parseInt(`${pageTotal / pageSize}`);
  const rem = pageTotal % pageSize;
  return basic + (rem ? 1 : 0);
};
export const getPageItemCount = (startPage, endPage, pageTotal, pageSize) => {
  if (!pageTotal || !pageSize) {
    return 0;
  }
  const basic = parseInt(`${pageTotal / pageSize}`);
  const rem = pageTotal % pageSize;
  const pageCount = basic + (rem ? 1 : 0);
  const arr = new Array(pageCount).fill(pageSize);
  if (rem) {
    arr[arr.length - 1] = rem;
  }
  return arr.slice(startPage - 1, endPage).reduce((acc, cur) => {
    acc = acc + cur;
    return acc;
  }, 0);
};
